import { Navigate, Outlet } from "react-router";
import { PageSkeleton } from "@/components/ui/skeleton";
import { useAuth } from "@/lib/auth-context";
import { useOrg } from "@/lib/org-context";

export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <PageSkeleton />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function RequirePlatformAdmin() {
  const { user, loading } = useAuth();
  if (loading) return <PageSkeleton />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isPlatformAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function RequireMembership() {
  const { organizations, loading, user } = useAuth();
  if (loading) return <PageSkeleton />;
  if (!user) return <Navigate to="/login" replace />;
  if (!organizations[0]) return <Navigate to="/onboarding" replace />;
  return <Outlet />;
}

export function RequireOrgAdmin() {
  const { loading } = useAuth();
  const { organization, role } = useOrg();
  if (loading) return <PageSkeleton />;
  if (!organization) return <Navigate to="/onboarding" replace />;
  if (role !== "owner" && role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
